// Figma "Shell/AuthShell — Narrow" (33:316 / 33:923 / 33:945) — the centred
// card the six S1 auth frames share. Not `ui/Card`: Card is 24px padding /
// fluid width / no wordmark header, this is 32px padding / a fixed 420px /
// a locked wordmark row, and exactly three screens (all owned by this
// agent) need the shape. Forking a primitive for a one-shape need is the
// wrong direction; a local component for a three-owner shape is the right
// one.
//
// Deliberately does NOT instance Screen/Template — no sidebar, no topbar,
// per CLAUDE.md §Design file. Stamps data-chassis="paper" itself since no
// AppShell wraps these pre-login screens.

import "../../tokens/paper.css";
import "./auth.css";
import type { ReactNode } from "react";

export type AuthShellProps = {
  children: ReactNode;
};

export function AuthShell({ children }: AuthShellProps) {
  return (
    <div className="maisight-signin-page" data-chassis="paper">
      <div className="maisight-signin-card">
        <div className="maisight-signin-wordmark">
          <span className="maisight-signin-wordmark-dot" aria-hidden="true" />
          <span className="maisight-signin-wordmark-text type-label">
            mAiSight
          </span>
        </div>
        <div className="maisight-signin-slot">{children}</div>
      </div>
    </div>
  );
}
